$( document ).ready( function() {
	$('.js-select').select2({
		language: 'ru',
		width: '100%',
		minimumResultsForSearch: -1,
	});
	$('.js-select-xs').select2({
		language: 'ru',
		width: '100%',
		minimumResultsForSearch: -1,
		containerCssClass: 'select-xs',
		dropdownCssClass: 'select-xs-dropdown'
	});

	function flagResultState( state ) {
		if ( !state.id ) {
			return state.text;
		}
		var baseUrl = "img/flags";
		var $state = $(
			'<span><img src="' + baseUrl + '/' + state.element.value.toLowerCase() + '.png" class="img-flag" /> ' + state.text + '</span>'
		);
		return $state;
	}
	function flagSelectionState( state ) {
		if ( !state.id ) {
			return state.text;
		}
		var baseUrl = 'img/flags';
		var $state = $(
			'<span><img class="img-flag" /> <span></span></span>'
		);
		// Use .text() instead of HTML string concatenation to avoid script injection issues
		$state.find( 'span' ).text(state.text);
		$state.find( 'img' ).attr( 'src', baseUrl + '/' + state.element.value.toLowerCase() + '.png' );

		return $state;
	}

	$( '.js-select-country' ).select2({
		language: 'ru',
		width: '100%',
		minimumResultsForSearch: -1,
		templateResult: flagResultState,
		templateSelection: flagSelectionState,
	});

	$( document ).on( 'click', '.main-scheme__box-tab li', function () {
		if ( !$( this ).hasClass( 'active' ) ) {
			$( '.main-scheme__box-tab li' ).removeClass( 'active' );
			$( this ).addClass( 'active' );
			$( '.main-scheme__box-text' ).removeClass( 'show' );
			$( '.main-scheme__box-text[data-tab="' + $( this ).attr( 'data-tab' ) + '"]' ).addClass( 'show' );
		}
		if ( window.matchMedia( '(max-width: 991px)' ).matches ){
			$('html, body').animate({'scrollTop': $('.main-scheme__box-content').offset().top - 100}, 600);
		}
	});

	$(document).on('click', '.footer-title', function () {
		if ( window.matchMedia( '(max-width: 767px)' ).matches ) {
			const $parent = $(this).closest('.footer-box');
			if (!$parent.hasClass('show')){
				$parent.addClass('show');
				$parent.find('.footer-menu').slideDown(300);
			} else {
				$parent.removeClass('show');
				$parent.find('.footer-menu').slideUp(300);
			}
		}
	});
	$(window).on('resize', function () {
		if ( window.matchMedia( '(min-width: 768px)' ).matches ){
			$('.footer-box').removeClass('show');
			$('.footer-menu').css('display', '');
		}
	});

	if ( $( '.main-faq__category' ).length ) {
		$( '.main-faq__category-box' ).each( function () {
			if ( $( this ).hasClass( 'show' ) ) {
				$( this ).find( '.main-faq__category-list' ).slideDown( 300 );
			}
		});
		$( '.main-faq__question-group' ).each( function () {
			if ( $( this ).hasClass( 'show' ) ) {
				$( this ).show();
			}
		})
		$( document ).on( 'click', '.js-faq-category', function () {
			const $this = $( this ),
				$parent = $this.closest( '.main-faq__category-box' );
			if ( !$parent.hasClass( 'show' ) ) {
				$( '.main-faq__category-box' ).removeClass( 'show' );
				$parent.addClass( 'show' );
				$( '.main-faq__category-list' ).slideUp( 300 );
				$parent.find( '.main-faq__category-list' ).slideDown( 300 );
			} else {
				$parent.removeClass( 'show' );
				$parent.find( '.main-faq__category-list' ).slideUp( 300 );
			}
		});
		$( document ).on( 'click', '.main-faq__category-list li', function () {
			const $this = $( this ),
				$parent = $this.closest( '.main-faq__category-list' );
			if ( !$this.hasClass( 'active' ) ) {
				$( '.main-faq__category-list li' ).removeClass( 'active' );
				$this.addClass( 'active' );
				$( '.main-faq__question-group' ).removeClass( 'show' );
				$( '.main-faq__question-group[data-type="' + $this.attr( 'data-type' ) + '"]' ).addClass( 'show' );
			}
			if ( window.matchMedia( '(max-width: 991px)' ).matches ) {
				$( 'html, body' ).animate( {'scrollTop': $( '.main-faq__question' ).offset().top - 130}, 600 );
			}
		});
		$( document ).on( 'click', '.js-faq-question', function () {
			const $this = $( this ),
				$parent = $this.closest( '.main-faq__question-box' );
			if ( !$parent.hasClass( 'show' ) ) {
				$( '.main-faq__question-box' ).removeClass( 'show' );
				$parent.addClass( 'show' );
				$( '.main-faq__question-box-text' ).slideUp( 300 );
				$parent.find( '.main-faq__question-box-text' ).slideDown( 300 );
			} else {
				$parent.removeClass( 'show' );
				$parent.find( '.main-faq__question-box-text' ).slideUp( 300 );
			}
		});
	}

	function initSchemeSlider() {
		if ( window.matchMedia( '(max-width: 991px)' ).matches ) {
			$( '.js-scheme-slider' ).slick({
				infinite: false,
				slidesToShow: 2,
				slidesToScroll: 1,
				arrows: false,
				dots: true,
				swipeToSlide: true,
				responsive: [
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							adaptiveHeight: true,
						}
					}
				]
			});
		}
	}
	initSchemeSlider();
	$( window ).resize( function() {
		if ( $( '.js-scheme-slider' ).hasClass( 'slick-initialized' ) && window.matchMedia( '(min-width: 992px)' ).matches ) {
			$( '.js-scheme-slider' ).slick( 'unslick' );
		} else if ( !$( '.js-scheme-slider' ).hasClass( 'slick-initialized' ) ) {
			initSchemeSlider();
		}
	});

	function rebuildDiscount() {
		const $discount = $( '.main-discount__box-title' ).detach();
		if ( window.matchMedia( '(max-width: 991px)' ).matches ){
			$discount.prependTo( '.main-discount__box' );
		} else {
			$discount.prependTo( '.main-discount__box-body' );
		}
	}
	$( window ).on( 'resize', function () {
		rebuildDiscount();
	});
	rebuildDiscount();
});
